

export const acceptJSON = {"application/json": [".json"]};